import addTrailingSlashToPath from './addTrailingSlashToPath'

export default to => {
  window.location = addTrailingSlashToPath(to)
}
